import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import EmployeeSalesUserList from '../../components/EmployeeSalesTarget/EmployeeSalesUserList';
const EmployeeSalesUserListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <EmployeeSalesUserList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default EmployeeSalesUserListPage;